//
import React, { Component } from "react"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { EventParticipantTypeFilter } from "shared/search/containers/Filter/EventParticipantFilters"

export class EventParticipantTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [EventParticipantTypeFilter],
        uniqueFilterGroupId: "EventParticipantTypeFilterGroup",
        displayLabel: "Participant Type",
        helpText: "Filter for types of participants in this event.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
